// src/components/AppleWalletButton.js

import React, { useState } from 'react';
import apiClient from '../apiClient';
import { useParticipantAuth } from '../context/ParticipantAuthContext';
import './AppleWalletButton.css'; // We will update this CSS file

// Import the SVG file directly into your component.
// Webpack will handle the path correctly.
import appleWalletBadge from '../assets/icons/US-UK_Add_to_Apple_Wallet_RGB_101421.svg';

const AppleWalletButton = () => {
    const { programId } = useParticipantAuth();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const handleAddToWalletClick = async () => {
        if (!programId) {
            setError("Program information is missing. Cannot download pass.");
            return;
        }

        setIsLoading(true);
        setError('');

        try {
            const response = await apiClient.get(
                `/public/wallet/apple/programs/${programId}/pass`,
                {
                    responseType: 'blob',
                }
            );

            const blob = new Blob([response.data], { type: 'application/vnd.apple.pkpass' });
            const url = window.URL.createObjectURL(blob);
            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

            if (isIOS) {
                window.location.href = url;
            } else {
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'ZappyRewardsPass.pkpass');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
            setTimeout(() => window.URL.revokeObjectURL(url), 60_000);

        } catch (err) {
            console.error("Failed to download Apple Wallet pass:", err);
            const errorMsg = err.response?.data?.detail || "Could not download the pass at this time. Please try again later.";
            setError(errorMsg);
            alert(`Error: ${errorMsg}`);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="apple-wallet-button-container">
            {/* Using an `<img>` tag inside a button is great for accessibility.
              The button is focusable, clickable, and the alt text describes the image.
            */}
            <button 
                onClick={handleAddToWalletClick} 
                disabled={isLoading}
                className="apple-wallet-button-svg"
                aria-label="Add to Apple Wallet" // For screen readers
            >
                <img src={appleWalletBadge} alt="Add to Apple Wallet" />
            </button>
            {isLoading && <p className="wallet-button-loading">Generating...</p>}
            {error && <p className="wallet-button-error">{error}</p>}
        </div>
    );
};

export default AppleWalletButton;
